import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function CanopyIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="60" height="60" viewBox="0 0 60 60" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          'M55.9757 5.59055C56.142 5.2586 55.8897 4.89067 55.5184 4.88967L4.48775 4.75228C4.115 4.75128 3.86037 5.12017 4.0278 5.4532C7.05096 11.4664 28.4514 54.0306 ' +
          '28.6997 54.4577C28.9669 54.9172 29.3799 55.2499 29.9842 55.2499C30.5885 55.2499 31.1903 54.9776 31.3757 54.6564C31.5481 54.3579 52.9655 11.6003 55.9757 5.59055Z' +
          'M13.8831 9.97009C13.512 9.97009 13.2702 10.3601 13.4353 10.6925L31.6631 47.396C31.8467 47.7657 32.3738 47.7663 32.5582 47.397L50.8861 10.6935C51.0521 10.361 ' +
          '50.8104 9.97009 50.4388 9.97009H13.8831Z'
        }
        fill="black"
      />
    </SvgIcon>
  );
}

export default CanopyIcon;
